(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-liquid"] && !Shopify.designMode) return;
  try {
    
  class KaracaMegaMenu extends HTMLElement {
    constructor() {
      super();
      this.tabs = this.querySelectorAll('[role="tab"]');
      this.panels = this.querySelectorAll('[role="tabpanel"]');
      
      this.tabs.forEach(tab => {
        tab.addEventListener('mouseover', this.onTabHover.bind(this));
        tab.addEventListener('focus', this.onTabHover.bind(this));
      });
    }
    
    onTabHover(event) {
      const activeTab = event.currentTarget;
      const targetPanelId = activeTab.dataset.target;
      
      // Tüm tabları ve panelleri sıfırla
      this.tabs.forEach(tab => {
        tab.classList.remove('is-active');
        tab.setAttribute('aria-selected', 'false');
      });
      
      this.panels.forEach(panel => {
        panel.classList.remove('is-active');
      });
      
      // Aktif olanı ayarla
      activeTab.classList.add('is-active');
      activeTab.setAttribute('aria-selected', 'true');
      
      const targetPanel = this.querySelector(targetPanelId);
      if (targetPanel) {
        targetPanel.classList.add('is-active');
      }
    }
  }

  if (!customElements.get('karaca-mega-menu')) {
    customElements.define('karaca-mega-menu', KaracaMegaMenu);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-slideshow')) {
    class CustomSlideshow extends HTMLElement {
      constructor() {
        super();
        this.container = this.querySelector('.slideshow-container');
        this.slides = this.querySelectorAll('.slideshow-slide');
        this.prevBtn = this.querySelector('.slideshow-arrow.prev');
        this.nextBtn = this.querySelector('.slideshow-arrow.next');
        this.dots = this.querySelectorAll('.slideshow-dot');
        this.counterCurrent = this.querySelector('.slideshow-counter-current');
        
        this.autoplay = this.dataset.autoplay === 'true';
        this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10);
        this.currentIndex = 0;
        this.timer = null;

        if (this.slides.length < 2) return;

        this.init();
      }

      init() {
        this.nextBtn.addEventListener('click', () => this.goToSlide(this.currentIndex + 1, true));
        this.prevBtn.addEventListener('click', () => this.goToSlide(this.currentIndex - 1, true));
        
        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.goToSlide(index, true));
        });

        if (this.autoplay) {
          this.startAutoplay();
          const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
              this.startAutoplay();
            } else {
              this.stopAutoplay();
            }
          });
          observer.observe(this);
        }
        
        // Sürükleme (Drag/Swipe) desteği
        this.isDragging = false;
        this.startX = 0;
        this.currentTranslate = 0;
        this.prevTranslate = 0;

        this.slides.forEach(slide => {
          slide.addEventListener('dragstart', (e) => e.preventDefault());
        });

        this.container.addEventListener('mousedown', this.dragStart.bind(this));
        this.container.addEventListener('touchstart', this.dragStart.bind(this));

        this.container.addEventListener('mouseup', this.dragEnd.bind(this));
        this.container.addEventListener('mouseleave', this.dragEnd.bind(this));
        this.container.addEventListener('touchend', this.dragEnd.bind(this));

        this.container.addEventListener('mousemove', this.drag.bind(this));
        this.container.addEventListener('touchmove', this.drag.bind(this));
      }

      dragStart(event) {
        this.stopAutoplay();
        this.isDragging = true;
        this.startX = this.getEventPositionX(event);
        this.container.style.transition = 'none';
        this.prevTranslate = this.currentIndex * -this.slides[0].offsetWidth;
      }

      drag(event) {
        if (!this.isDragging) return;
        const currentPosition = this.getEventPositionX(event);
        this.currentTranslate = this.prevTranslate + currentPosition - this.startX;
        this.container.querySelector('.slideshow-slides').style.transform = `translateX(${this.currentTranslate}px)`;
      }

      dragEnd(event) {
        if (!this.isDragging) return;
        this.isDragging = false;
        const movedBy = this.currentTranslate - this.prevTranslate;
        
        if (movedBy < -100) { // Sağa kaydır (sonraki)
          this.goToSlide(this.currentIndex + 1);
        } else if (movedBy > 100) { // Sola kaydır (önceki)
          this.goToSlide(this.currentIndex - 1);
        } else {
          this.goToSlide(this.currentIndex); // Pozisyona geri dön
        }
        
        this.container.style.transition = '';
        if (this.autoplay) this.startAutoplay();
      }
      
      getEventPositionX(event) {
        return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
      }

      goToSlide(index, userInitiated = false) {
        if (userInitiated) this.stopAutoplay();

        if (index < 0) {
          this.currentIndex = this.slides.length - 1;
        } else if (index >= this.slides.length) {
          this.currentIndex = 0;
        } else {
          this.currentIndex = index;
        }

        const offset = this.currentIndex * this.slides[0].offsetWidth;
        this.container.querySelector('.slideshow-slides').style.transform = `translateX(-${offset}px)`;

        this.updateControls();
        
        if (userInitiated && this.autoplay) this.startAutoplay();
      }

      updateControls() {
        this.dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === this.currentIndex);
        });
        if (this.counterCurrent) {
          this.counterCurrent.textContent = this.currentIndex + 1;
        }
      }

      startAutoplay() {
        this.stopAutoplay(); // Önceki timer'ı temizle
        if (!this.autoplay) return;
        this.timer = setInterval(() => {
          this.goToSlide(this.currentIndex + 1);
        }, this.autoplaySpeed);
      }

      stopAutoplay() {
        clearInterval(this.timer);
      }
    }
    customElements.define('custom-slideshow', CustomSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderStickyManager extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.header-wrapper');
      this.placeholder = document.querySelector('.header-placeholder');
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    }
    disconnectedCallback() { window.removeEventListener('scroll', this.onScrollHandler); }
    onScroll() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      if (scrollTop > 100) {
        if (!this.header.classList.contains('is-pinned')) { this.header.classList.add('is-pinned'); this.placeholder.classList.add('is-visible'); }
      } else {
        if (this.header.classList.contains('is-pinned')) { this.header.classList.remove('is-pinned'); this.placeholder.classList.remove('is-visible'); }
      }
    }
  }
  if (!customElements.get('header-sticky-manager')) { customElements.define('header-sticky-manager', HeaderStickyManager); }
  const stickyManager = document.createElement('header-sticky-manager');
  document.body.appendChild(stickyManager);

  class KaracaMegaMenu extends HTMLElement {
    constructor() {
      super();
      this.tabs = this.querySelectorAll('[role="tab"]');
      this.panels = this.querySelectorAll('[role="tabpanel"]');
      this.tabs.forEach(tab => tab.addEventListener('mouseenter', this.onTabHover.bind(this)));
    }
    onTabHover(event) {
      const activeTab = event.currentTarget;
      const targetPanelId = activeTab.dataset.target;
      this.tabs.forEach(t => t.classList.remove('is-active'));
      this.panels.forEach(p => p.classList.remove('is-active'));
      activeTab.classList.add('is-active');
      const targetPanel = this.querySelector(targetPanelId);
      if(targetPanel) targetPanel.classList.add('is-active');
    }
  }
  if (!customElements.get('karaca-mega-menu')) { customElements.define('karaca-mega-menu', KaracaMegaMenu); }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["karaca-mega-menu"] && !Shopify.designMode) return;
  try {
    
  // MASAÜSTÜ
  class KaracaMegaMenu extends HTMLElement {
    constructor() {
      super();
      this.tabs = this.querySelectorAll('[role="tab"]');
      this.panels = this.querySelectorAll('[role="tabpanel"]');
      this.tabs.forEach(tab => tab.addEventListener('mouseenter', this.onTabHover.bind(this)));
    }
    onTabHover(event) {
      const activeTab = event.currentTarget;
      const targetPanelId = activeTab.dataset.target;
      this.tabs.forEach(t => t.classList.remove('is-active'));
      this.panels.forEach(p => p.classList.remove('is-active'));
      activeTab.classList.add('is-active');
      const targetPanel = this.querySelector(targetPanelId);
      if(targetPanel) targetPanel.classList.add('is-active');
    }
  }
  customElements.define('karaca-mega-menu', KaracaMegaMenu);

  /*
  // MOBİL GLOBAL (KAPALI)
  window.toggleMobileDrawer = function() {
    const drawer = document.getElementById('mobileDrawer');
    const overlay = document.getElementById('drawerOverlay');
    const isOpen = drawer.classList.contains('is-open');
    if (isOpen) {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    } else {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  }

  window.toggleAccordion = function(arrow) {
    const sublist = arrow.parentElement.nextElementSibling;
    arrow.classList.toggle('rotated');
    if (sublist.style.maxHeight) {
      sublist.style.maxHeight = null;
    } else {
      sublist.style.maxHeight = sublist.scrollHeight + "px";
    }
  }
  */

  } catch(e) { console.error(e); }
})();
})();
